import { useAccommodationsConsoleHotelsSortOrderQuery } from '../AccommodationsConsole.graphql.generated';
import { addAction, addError } from '@shared/utils/logger';

type UseAccommodationsSortOrderArgs = Readonly<{
  eventHandle: Maybe<string>;
  skip?: boolean;
}>;

export const useAccommodationsSortOrder = ({ eventHandle, skip = false }: UseAccommodationsSortOrderArgs) => {
  const { data: pageContainerData, loading } = useAccommodationsConsoleHotelsSortOrderQuery({
    variables: {
      payload: {
        eventName: eventHandle || '',
        pageSlug: 'accommodations',
      },
    },
    onCompleted: data => {
      if (data?.pageContainerBySlug?.components?.[0]?.__typename === 'TravelMapComponent' && !data?.pageContainerBySlug?.components?.[0]?.blockOrdering?.length) {
        addAction('Accommodations block ordering is empty (AccommodationsConsole)', {
          context: 'blockOrdering',
          eventHandle,
        });
      }
    },
    onError: error => {
      addError(error, {
        source: 'Accommodations block ordering api failed (AccommodationsConsole)',
        context: 'blockOrdering',
        errorMessage: error.message,
        eventHandle,
      });
    },
    skip: skip || !eventHandle,
    fetchPolicy: 'cache-and-network',
    batchMode: 'fast',
  });

  return {
    loading,
    pageContainerBySlug:
      pageContainerData?.pageContainerBySlug?.components?.[0]?.__typename === 'TravelMapComponent' ? pageContainerData?.pageContainerBySlug?.components?.[0] : null,
  };
};
